var map = {
	"./01.png": 5924,
	"./02.png": 6669,
	"./03.png": 4175,
	"./04.png": 6209,
	"./05.png": 5426,
	"./403.svg": 8050,
	"./404.svg": 8370,
	"./Group 119.png": 9597,
	"./Group 121.png": 5219,
	"./Group 1623.png": 3423,
	"./Group 1627.png": 9017,
	"./Group 1645.png": 7176,
	"./Group 1651.png": 9495,
	"./Group 1667.png": 3542,
	"./Group 1668.png": 7475,
	"./Group 1669.png": 764,
	"./Group 1671.png": 4830,
	"./Group 2.png": 4846,
	"./Group 61.png": 1134,
	"./Group 614.png": 637,
	"./Group 615.png": 3619,
	"./Group 96.png": 6063,
	"./Path 52.png": 5811,
	"./bg.png": 5088,
	"./cand_search.svg": 4018,
	"./candidate_search.svg": 5628,
	"./candidates.svg": 476,
	"./company.jpg": 2377,
	"./const1.svg": 4569,
	"./consult.svg": 9987,
	"./dash.svg": 7315,
	"./dash1.svg": 4894,
	"./dash12.svg": 7014,
	"./delete.svg": 2352,
	"./devsinc.png": 7855,
	"./dummy": 9925,
	"./dummy.js": 9925,
	"./edit.png": 4505,
	"./edit.svg": 1973,
	"./employee.svg": 8961,
	"./girl.png": 8334,
	"./illustrations.png": 3768,
	"./illustrations2.png": 9808,
	"./img1.png": 9350,
	"./img2.png": 6806,
	"./img3.png": 602,
	"./job.svg": 679,
	"./mail.svg": 9357,
	"./page_not_found.svg": 7782,
	"./person.jpg": 7730,
	"./profile.webp": 4905,
	"./recruuitLogo.png": 6047,
	"./roles.svg": 9525,
	"./talha_tariq.jpg": 3595,
	"./talha_tariq1.jpeg": 9352,
	"./visibility.svg": 3945,
	"./warning.svg": 1546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;